import { render, staticRenderFns } from "./BootstrapCheckbox.vue?vue&type=template&id=6ca10230"
import script from "./BootstrapCheckbox.vue?vue&type=script&lang=ts"
export * from "./BootstrapCheckbox.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports